'use client'

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { useCurrentUser } from '@/hooks/use-current-user'
import { Button } from '@/shared/ui/button'
import { cn } from '@/utils/cn'
import { zodResolver } from '@hookform/resolvers/zod'
import Image from 'next/image'
import { HTMLAttributes } from 'react'
import { useForm } from 'react-hook-form'

import { useFullDomainUrl } from '@/hooks/use-full-domain-url'
import { z } from 'zod'
import { useSendConfirmEmail } from '../../hooks/use-send-confirm-email'
import { toast } from 'sonner'

const formSchema = z.object({
  email: z.string().email({
    message: '올바르지 않은 이메일 형식입니다.',
  }),
})

type ConfirmEmailSendFormProps = {
  onSuccess: (email: string) => void
}

export const ConfirmEmailSendForm = ({
  className,
  onSuccess,
  ...props
}: ConfirmEmailSendFormProps & HTMLAttributes<HTMLDivElement>) => {
  const { user } = useCurrentUser()
  const { mutate } = useSendConfirmEmail()
  const domain = useFullDomainUrl()

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: user?.providerEmail ?? '',
    },
  })
  // 2. Define a submit handler.
  function onSubmit(values: z.infer<typeof formSchema>) {
    mutate(
      {
        email: values.email,
        returnUrl: domain,
      },
      {
        onSuccess: () => {
          onSuccess(values.email)
        },
        onError: () => {
          toast.error('이메일 발송에 실패했어요.')
        },
      },
    )
  }
  return (
    <div className={cn(className)} {...props}>
      <div className="flex flex-col items-center justify-center gap-8">
        <div className="text-center font-semibold">
          <h2>가격 알림을 받기 위해서</h2>
          <h2>이메일 인증이 필요해요</h2>
        </div>
        <Image
          src="/icons/이메일인증모달_메일.svg"
          alt="이메일 인증"
          width={100}
          height={100}
        />

        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>이메일</FormLabel>
                  <FormControl>
                    <Input placeholder="이메일을 입력해주세요." {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <Button className="w-full" variant={'primary'}>
              인증메일 받기
            </Button>
            <p className="text-caption-01-medium text-gray-5">
              원활한 알림 서비스 제공을 위해 이메일의 소유권을 확인하고 있어요.
              이메일 인증 절차는 최초 1회만 진행합니다.
            </p>
          </form>
        </Form>
      </div>
    </div>
  )
}
